export default "__VITE_ASSET__DNep$m94__"